<template>
  <button class="btn search-item__toggle-btn" @click.prevent="toggleList">
    {{btn_title}} <i aria-hidden="true" class="fas " :class="iconClass"></i>
  </button>
</template>
<script>
import { bus } from './bus.js'
export default {
  props:["id"],
  data() {
    return {
      btn_title:'Скрыть список',
      list_show:true,
      iconClass: 'fa-chevron-up',
    }
  },
  methods: {
    toggleList() {
      this.list_show = !this.list_show;
      bus.$emit('list-toggle',{id:this.id, status:this.list_show});
      if(this.list_show) {
        this.iconClass = 'fa-chevron-up';
        this.btn_title = 'Скрыть список';
      } else {
        this.iconClass = 'fa-chevron-down';
        this.btn_title = 'Показать список';
      }
    }
  }
}
</script>